document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.media-with-text');

  if (!('IntersectionObserver' in window)) {
    // Fallback: just show everything
    sections.forEach(sec => sec.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          // remove class when out of view so it fades back out
          entry.target.classList.remove('is-visible');
        }
      });
    },
    {
      threshold: 0.2
    }
  );

  sections.forEach(section => observer.observe(section));
});
